import { render, staticRenderFns } from "./RiskReturn.vue?vue&type=template&id=2911db7c&"
import script from "./RiskReturn.vue?vue&type=script&lang=js&"
export * from "./RiskReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports